// extracted by mini-css-extract-plugin
export default {"badge":"priority-tag_badge__kOd0u","badge_opacity":"priority-tag_badge_opacity__3fBaD"};